import './front.scss';

import domReady from "@wordpress/dom-ready";

domReady(function () {
  const header = document.querySelector("header");
  const offset = header.offsetTop + 100;

  window.addEventListener("scroll", function () {
    if (window.scrollY > offset) {
      header?.classList.add("is-sticky");
    } else {
      header?.classList.remove("is-sticky");
    }
  });
});

